<template>
  <div>
    <yw-head></yw-head>
    <div class="web-body">
      <div class="chu_ti">
        <h2>猜歌达人用户出题版权声明</h2>
      </div>
      <div class="tips">
        <h5>
          《猜歌达人》一向十分重视网络版权及其他知识产权及以用户权益的保护，如果您认为《猜歌达人》游戏内用户分享的音乐等内容侵犯了您的相关权益的，请您向《猜歌达人》提出投诉，《猜歌达人》将根据相关法律规定采取措施删除相关内容，您可以向《猜歌达人》所设立的专门接受版权投诉和侵权通知的邮箱发送投诉请求。
        </h5>
        
        
        <h4> 版权申诉 </h4>
        
        
        <h5> 侵犯个人或单位的著作权、商标权等知识产权的情况请将投诉资料发至： tousu@yongwangkeji.cn</h5>
        
        <h4> 申诉需知</h4>
        
        
        <h5> 投诉方应当提供包含下列文件：</h5>
        
        
        <h6> 1、邮件格式：标题（作品名+权利人）+正文（诉求描述）</h6>
        
        <h6> 2、权利人的姓名（名称）、联系方式、地址、身份证扫描件（自然人）、企业法人营业执照（单位）、法定代表人身份证明（单位）；</h6>
        
        <h6> 3、 要求删除的侵权作品的准确名称，以便《猜歌达人》能够发现并初步审核涉嫌侵权作品；</h6>
        
        <h6> 4、 认为构成侵权的初步证明材料，包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明，以及对涉嫌侵权作品侵权事实的举证。</h6>
        
        
        <h6> 一旦收到符合上述要求之通知，我们将在合理时间内删除涉嫌侵权的作品。如不符合上述条件，我们会请阁下提供相应信息，且暂不采取包括删除等相应措施。</h6>
        
        
        <h6>
          在《猜歌达人》上载作品的用户视为同意《猜歌达人》就前款情况所采用的相应措施。《猜歌达人》不因此而承担任何违约责任或其他任何法律责任。《猜歌达人》在收到上述通知后会发送电子邮件通知上载该等作品的用户。对于多次上载涉嫌侵权作品的用户，我们将取消其用户资格。</h6>
        
        
        <h6> 在您发送邮件后，工作人员会尽快处理，由于涉及内容不同，所需周期也不同，请您耐心等待。猜歌达人工作人员将会在有具体投诉处理结果后，以回复邮件的形式将结果发送给您。</h6>
      </div>
    </div>
    
    
    <yw-footer></yw-footer>
  
  </div>

</template>

<script>
  
  import yw_head from './yw_head';
  import yw_footer from './yw_footer';
  
  export default {
    name: "chu_ti_ban_quan",
    components: {
      'yw-head': yw_head,
      'yw-footer': yw_footer
    }
  }
</script>

<style scoped>
  .tips {
    color: #888;
    margin: 50px auto;
  }
  
  .chu_ti_form_box {
    background: #eee;
    padding: 50px;
    margin: 50px auto;
    border-radius: 10px;
  }
  
  .radio_text {
    display: inline-block;
    margin-left: 4px;
    color: #666;
  }
  
  .ban_quan {
    color: #1179FF;
  }
  
  h4 {
    
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/chu_ti_ban_quan.vue